import { Component, input, InputSignal, OnInit, output, OnChanges, SimpleChanges, model, OutputEmitterRef, ModelSignal } from '@angular/core';
import { IonModal, IonButton } from "@ionic/angular/standalone";

@Component({
  selector: 'app-confirm-modal',
  templateUrl: './confirm-modal.component.html',
  styleUrls: ['./confirm-modal.component.scss'],
  imports: [IonButton, IonModal]
})
export class ConfirmModalComponent  implements OnInit, OnChanges {
  public isOpen: ModelSignal<boolean> = model<boolean>(false);
  public content: InputSignal<string> = input<string>('');
  public confirm: OutputEmitterRef<void>  = output<void>();

  constructor() { }

  ngOnChanges(changes: SimpleChanges) {
    this.isOpen.set(changes['isOpen'].currentValue);
  }

  ngOnInit() {
  }

  validate() {
    this.confirm.emit();
    this.isOpen.set(false);
  }
}
